import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Button, Flex, Heading, Stack } from '@chakra-ui/react';

import { ItemsHistory } from './ItemsHistory';
import { CasesHistory } from './CasesHistory';
import { PackagesHistory } from './PackagesHistory';
import { UserPill } from 'components/core/UserPill';
import useQueryParams from 'hooks/useQueryParams';

import { HistoryViewProps } from './History.props';

const HistoryView: FC<HistoryViewProps> = () => {
  const queryUrl = useQueryParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isType = (value: string): value is 'item' | 'packg' | 'case' => {
    return ['item', 'packg', 'case'].includes(value);
  };

  const [type, setType] = useState<'item' | 'packg' | 'case'>(
    queryUrl.compType && isType(queryUrl.compType) ? queryUrl.compType : 'item',
  );

  useEffect(() => {}, [type]);

  return (
    <Flex flex={1} direction="column" color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading mb={6} fontSize="24px">
          History
        </Heading>
        <UserPill />
      </Flex>
      <Stack mb={6} isInline>
        <Button
          w="180px"
          borderRadius="5px"
          variant={type === 'item' ? 'solid' : 'outline'}
          size="lg"
          onClick={() => {
            navigate(`${location.pathname}`);
            setType('item');
          }}>
          Items
        </Button>
        <Button
          w="180px"
          borderRadius="5px"
          variant={type === 'case' ? 'solid' : 'outline'}
          size="lg"
          onClick={() => {
            navigate(`${location.pathname}`);
            setType('case');
          }}>
          Cases
        </Button>
        <Button
          w="180px"
          borderRadius="5px"
          variant={type === 'packg' ? 'solid' : 'outline'}
          size="lg"
          onClick={() => {
            navigate(`${location.pathname}`);
            setType('packg');
          }}>
          Packages
        </Button>
      </Stack>
      {type === 'item' ? (
        <ItemsHistory />
      ) : type === 'case' ? (
        <CasesHistory />
      ) : (
        <PackagesHistory />
      )}
    </Flex>
  );
};

export default HistoryView;
